import styled from "styled-components";
import { BasicBUTTON } from "./Basics";

export const Button = styled(BasicBUTTON)``;